import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';
import {
  SFooter, useStore, useRouteRef, useVuetify, useOpenLinkNewTab,
} from '@slg/web-customer-shared';
import { normalizeExternalHref, normalizeExternalLinksInText } from '@slg/web-customer-shared/src/utils/externalLinks';
import appConfig from '@/appConfig';
import VueMarkdown from 'vue-markdown';


const __default__ = {
  name: 'Footer',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isFooterFullyShow: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {



const store = useStore();
const route = useRouteRef();
const vuetify = useVuetify();

const { setTargetAttributeToLink } = useOpenLinkNewTab();
const getStrappiCoreMenu = computed(() => store.getters['common/getStrappiCoreMenu']);
const getStrappiCoreSettings = computed(() => store.getters['common/getStrappiCoreSettings']);
const footerBottomLeft = computed(() => (
  normalizeExternalLinksInText(getStrappiCoreSettings.value?.footerBottomLeft || '')
));
const footerBottomRight = computed(() => (
  normalizeExternalLinksInText(getStrappiCoreSettings.value?.footerBottomRight || '')
));

watch(
  () => [footerBottomLeft.value, footerBottomRight.value],
  () => {
    setTargetAttributeToLink(['footer-additional']);
  },
  { immediate: true },
);

const getIsShownPrivacyPreferences = computed(() => appConfig.extendedCookieSupport);
const getIsMobile = computed(() => vuetify.breakpoint.xs);
const getIsCheckoutPage = computed(() => route.value.name === 'Checkout');

const getJobPage = computed(() => {
  if (route.value.params.lang === 'de') {
    return 'https://www.slg.lu/de/career/';
  }
  if (route.value.params.lang === 'fr') {
    return 'https://www.slg.lu/career/';
  }
  return 'https://www.slg.lu/en/career/';
});

const getPrivacyPolicyPage = computed(() => {
  if (route.value.params.lang === 'de') {
    return 'https://www.slg.lu/de/politique-de-confidentialite/';
  }
  if (route.value.params.lang === 'fr') {
    return 'https://www.slg.lu/politique-de-confidentialite/';
  }
  return 'https://www.slg.lu/en/politique-de-confidentialite/';
});

const menuItems = computed(() => [
  {
    strapiText: '',
    strapiKey: 'homeTitle',
    isAnotherDomain: false,
    title: 'footer.home',
    path: '/',
  },
  {
    title: 'footer.about',
    isAnotherDomain: false,
    path: { name: 'About' },
  },
  {
    title: 'footer.lost&found',
    isAnotherDomain: false,
    path: { name: 'ContactUs' },
  },
  {
    strapiText: '',
    isAnotherDomain: false,
    strapiKey: 'FAQTitle',
    title: 'footer.faq',
    path: { name: 'FAQ' },
  },
  {
    strapiText: '',
    isAnotherDomain: false,
    strapiKey: 'contactUsTitle',
    title: 'footer.contactUs',
    path: { name: 'ContactUs' },
  },
  {
    title: 'footer.jobs',
    isAnotherDomain: true,
    path: { name: getJobPage.value },
  },
  {
    strapiText: '',
    strapiKey: 'termsTitle',
    isAnotherDomain: false,
    title: 'footer.t&c',
    path: { name: 'TermsAndConditions' },
  },
  {
    strapiText: '',
    isAnotherDomain: false,
    strapiKey: 'sitemapTitle',
    title: 'footer.sitemap',
    path: { name: 'Sitemap' },
  },
  {
    strapiText: '',
    isAnotherDomain: true,
    strapiKey: 'policyTitle',
    title: 'footer.privacyPolicy',
    path: { name: getPrivacyPolicyPage.value },
  },
]);

function openCookieDialog() {
  store.commit('common/changeCookieDialogOpenState', true);
}

return { __sfc: true,store, route, vuetify, setTargetAttributeToLink, getStrappiCoreMenu, getStrappiCoreSettings, footerBottomLeft, footerBottomRight, getIsShownPrivacyPreferences, getIsMobile, getIsCheckoutPage, getJobPage, getPrivacyPolicyPage, menuItems, openCookieDialog, SFooter, normalizeExternalHref, VueMarkdown }
}

})